import { Directive, HostListener, inject } from '@angular/core';
import { LocalizationService } from '@core/services/localization';
import { BaseComponent } from '@core/utils/base-component';
import { HasChanges } from './models';

@Directive()
export abstract class UnsavedChangesBrowser extends BaseComponent implements HasChanges {
    public localizationService = inject(LocalizationService);

    public abstract hasChanges: boolean;

    public get autosaveInProgress(): boolean {
        return false;
    }

    @HostListener('window:beforeunload', ['$event'])
    public onBeforeUnload(event: BeforeUnloadEvent) {
        if (this.hasChanges || this.autosaveInProgress) {
            const keyword = this.autosaveInProgress ? 'str_common_autosaveInProgressLeaveDescription' : 'str_common_unsavedChangesDescription';
            event.returnValue = this.localizationService.instant(keyword);
            return event.returnValue;
        }

        return null;
    }
}
